import { DOCUMENT_CATEGORY_ENUM, IDocument } from "../@types/document";
import { IProductCrm } from "../@types/product";

export interface AppState {
    selectedCategory: DOCUMENT_CATEGORY_ENUM | undefined,
    docs: {
        items: IDocument[],
        loaded: boolean
    },
    product: IProductCrm,
}

export const initialAppState: AppState = {
    product: {
        seriale: null,
        prodotto: null,
        modello: null,
        codice_articolo: null,
        data_fine_costruzione: null,
        immagine: "",
        manuali: [],
        markets: [],
        certificato_garanzia: false,
    },
    selectedCategory: undefined,
    docs: {
        loaded: false,
        items: []
    }
}
